module.exports = __webpack_public_path__ + "IGDC2022-962cc1f4.webp";